import {
  useState, useRef, useCallback, useEffect,
} from 'react'

import useApiGet from 'Pods/Shared/Hooks/useApiGet'
import useApiPost from 'Pods/Shared/Hooks/useApiPost'

import { IMAGE_RESTORE_STATUS } from './constants'

const { IDLE, PENDING, CLOSED } = IMAGE_RESTORE_STATUS
const IMAGE_RESTORE_PATH = '/api/internal/items/image_restore'

function useImageRestore() {
  const [status, setStatus] = useState(IDLE)
  const [isInitialized, setIsInitialized] = useState(false)

  const { getData } = useApiGet()
  const { postData, isLoading: isTriggering } = useApiPost()

  // The restore runs in the background (up to ~3 days) - we only read the status
  // once on mount. It refreshes on the next page load, not by polling.
  const fetchStatus = useCallback(() => {
    getData({
      path: IMAGE_RESTORE_PATH,
      onSuccess: (response) => {
        setStatus(response.data.status)
        setIsInitialized(true)
      },
      onError: () => setIsInitialized(true),
    })
  }, [getData])

  const fetchStatusRef = useRef(fetchStatus)
  fetchStatusRef.current = fetchStatus

  const triggerRestore = useCallback(() => {
    setStatus(PENDING)

    postData({
      path: IMAGE_RESTORE_PATH,
      data: {},
      onSuccess: (response) => setStatus(response.data.status),
      onError: () => setStatus(IDLE),
    })
  }, [postData])

  const closeSection = useCallback(() => {
    setStatus(CLOSED)

    postData({ path: IMAGE_RESTORE_PATH, data: { status: CLOSED } })
  }, [postData])

  useEffect(() => {
    fetchStatusRef.current()
  }, [])

  return {
    status,
    isInitialized,
    isTriggering,
    triggerRestore,
    closeSection,
  }
}

export default useImageRestore
